import PepperIcon from '../../assets/images/Header/PepperIcon.svg';
import {
  LandingOverlayPage,
  LandingOverlayHeaderContainer,
  HeaderPepperIcon,
  LandingContentResized,
  LandingContainer,
  ContentBanner,
  BannerContainer,
  Banner,
  PositionedContainer,
  ImageBannerGoogle,
  ImageBannerApple,
} from './LandingOverlayStyledComponents';
import { Footer } from '../Footer/Footer';
import BannerSVG from '../../assets/images/Background/bannerWeb.webp';
import ImageApple from '../../assets/images/Background/Buttons/apple_button.svg';
import ImageGoogle from '../../assets/images/Background/Buttons/google_button.svg';
import { ViewMode } from '../../interfaces/Mode';
import { DesktopOnly } from '../../styles/GlobalStyledComponents';

interface Props {
  children: JSX.Element;
  iframeView: boolean;
  documentPage: boolean;
  documentPageBackground?: boolean;
  viewMode: ViewMode | null;
}

export const LandingOverlay = ({
  children,
  iframeView,
  documentPage,
  documentPageBackground,
  viewMode,
}: Props) => {
  const IOS_DOWNLOAD_LINK =
    'https://apps.apple.com/es/app/pepper-clientes/id6503949540';
  const ANDROID_DOWNLOAD_LINK =
    'https://play.google.com/store/apps/details?id=com.pepperfinance.clients';

  return (
    <LandingOverlayPage id="external-landing-header">
      <LandingOverlayHeaderContainer
        id="header"
        shown={!documentPage && !iframeView ? true : false}
      >
        <HeaderPepperIcon src={PepperIcon} alt="Pepper" />
      </LandingOverlayHeaderContainer>
      <LandingContainer
        id="background-container"
        shown={!documentPage ? true : false}
        backgroundMobile={documentPageBackground}
      >
        <ContentBanner id="content-banner">
          <LandingContentResized id="container-resized" shown={documentPage}>
            {children}
          </LandingContentResized>
          {viewMode !== ViewMode.APP && !iframeView && (
            <BannerContainer
              id="banner-container"
              shown={!documentPage && !iframeView ? true : false}
            >
              <DesktopOnly>
                <picture>
                  <source srcSet={BannerSVG} media="(min-width: 851px)" />
                  <Banner
                    src={BannerSVG}
                    alt="Pepper Banner Mobile"
                    title="Banner App Pepper"
                    width="261px"
                    height="624px"
                    id="banner-mobile-img"
                    loading="lazy"
                  />
                </picture>
                </DesktopOnly>
                <PositionedContainer>
                <DesktopOnly>
                  <picture>
                    <source srcSet={ImageApple} media="(min-width: 851px)" />
                    <ImageBannerApple
                      src={ImageApple}
                      alt="Image Apple"
                      title="Descargar en App Store"
                      width="95.29px"
                      height="32.79px"
                      id="banner-mobile-img"
                      loading="lazy"
                      onClick={() =>
                        window.open(
                          process.env.IOS_DOWNLOAD_LINK ?? IOS_DOWNLOAD_LINK
                        )
                      }
                    />
                  </picture>
                  </DesktopOnly>
                  <DesktopOnly>
                  <picture>
                    <source srcSet={ImageGoogle} media="(min-width: 851px)" />
                    <ImageBannerGoogle
                      src={ImageGoogle}
                      alt="Image Google"
                      title="Descargar en Google Play"
                      width="109.63px"
                      height="32.79px"
                      id="banner-mobile-img"
                      loading="lazy"
                      onClick={() =>
                        window.open(
                          process.env.ANDROID_DOWNLOAD_LINK ??
                            ANDROID_DOWNLOAD_LINK
                        )
                      }
                    />
                  </picture>
                  </DesktopOnly>
                </PositionedContainer>
            </BannerContainer>
          )}
        </ContentBanner>
      </LandingContainer>
      {!documentPage && !iframeView && <Footer viewMode={viewMode} />}
    </LandingOverlayPage>
  );
};
